import FeedLayout from "layouts/files/FeedLayout";
// import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import { RootState } from "services/redux/store";
import { SVG, SettingsToggler } from "ui";

const Notifications = () => {
    // const { avatar, name } = useSelector((state: RootState) => state.account);
    return (
        <FeedLayout pageTitle="Settings">
            <div className="settings-page">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/settings">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Notifications</h1>
                    <div></div>
                </div>
                <div className="card pl-10 pr-10 pt-10 pb-10">
                    <div className="w-full text-start pt-20 pl-15 pr-15">
                        <h2
                            className="fw-500 fs-12em"
                            style={{ textTransform: "uppercase" }}
                        >
                            Preferences
                        </h2>
                    </div>
                    {/* new followers */}
                    <SettingsToggler
                        svg="follow"
                        title="New Followers"
                        details="You will get Notifications once user will start following you."
                        defaultCheck
                    />
                    {/* likes */}
                    <SettingsToggler
                        svg="thumbs-up"
                        title="Likes"
                        details="You will get all your momeento post, incidents likes notifications."
                        defaultCheck
                    />
                    {/* comments */}
                    <SettingsToggler
                        svg="message-square"
                        title="Comments"
                        details="You will get all your momeento post, incidents likes notifications as well as Cuento Video post and photo post like notifications."
                        defaultCheck
                    />
                    {/* repost */}
                    <SettingsToggler
                        svg="repeat"
                        title="Repost Post or Incident"
                        details="You will get notification for someone who has reposted your Momeento Posts or Incidents."
                        defaultCheck
                    />
                    {/* followers tag */}
                    <SettingsToggler
                        svg="user"
                        title="Follower Tag you in their Posts, incidents etc."
                        details="You will get all your momeento post, incidents likes notifications as well as Cuento Video post and photo of your followers who mention you in their post."
                        defaultCheck
                    />
                    {/* followers message */}
                    <SettingsToggler
                        svg="message-circle"
                        title="Follower Message"
                        details="You will get notification for your direct followers message."
                        defaultCheck
                    />
                    {/* Group post */}
                    <SettingsToggler
                        svg="community"
                        title="Group Post"
                        details="You will get notification for your joined groups activity."
                        defaultCheck
                    />
                    {/* Group invitation */}
                    <SettingsToggler
                        svg="users-add"
                        title="Group Invitation"
                        details="You will get Notifications for someone will invite you to join their group."
                        defaultCheck
                    />
                    {/* Group invitation reply */}
                    <SettingsToggler
                        svg="rotate-left"
                        title="Group Invitation Reply"
                        details="From on your groups invitation Accept or decline by users notifications."
                        defaultCheck
                    />

                    {/* muted notificatoins */}
                    <div className="w-full text-start pt-20 pl-15 pr-15 mt-20">
                        <h2
                            className="fw-500 fs-12em"
                            style={{ textTransform: "uppercase" }}
                        >
                            muted notifications
                        </h2>
                    </div>
                    {/*default profile photo */}
                    <SettingsToggler
                        svg="user-add-slash"
                        title="Who have default profile photo"
                        details="Momeento users who having default photo and they will like your posts etc. you will not get notificationss for their activities on your posts."
                        defaultCheck
                    />
                    {/* you don't follow */}
                    <SettingsToggler
                        svg="user-slash"
                        title="You don't follow"
                        details="You will not get notification for momeento users who are not in your followers list."
                        defaultCheck
                        className="mb-30"
                    />
                </div>
            </div>
        </FeedLayout>
    );
};

export default Notifications;
